<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-LuoDiJia`]" width="1em" height="1em" v-bind="$attrs"><path d="M20.9323 19.7336H20.1323V3.73358H20.9323C21.3323 3.73358 21.7323 3.33358 21.7323 2.93358C21.7323 2.53358 21.3323 2.13358 20.9323 2.13358H3.06562C2.66562 2.00024 2.26562 2.40024 2.26562 2.80024C2.26562 3.20024 2.66562 3.60024 3.06562 3.60024H3.86562V19.6002H3.06562C2.66562 19.6002 2.26562 20.0002 2.26562 20.4002C2.26562 20.9336 2.66562 21.3336 3.06562 21.3336H3.86562C3.99896 21.7336 4.26562 22.0002 4.66562 22.0002C5.06562 22.0002 5.46562 21.7336 5.46562 21.3336H18.399C18.5323 21.7336 18.799 22.0002 19.199 22.0002C19.599 22.0002 19.999 21.7336 19.999 21.3336H20.799C21.199 21.3336 21.599 20.9336 21.599 20.5336C21.7323 20.0002 21.3323 19.7336 20.9323 19.7336ZM18.399 19.7336H5.59896V15.7336H18.399V19.7336ZM18.399 14.0002H5.59896V9.86691H18.399V14.0002ZM5.59896 8.26691V3.60024H18.399V8.26691H5.59896Z"/></svg>
</template>
<script>

export default {
  name: 'IconLuoDiJia',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
